import { formatters, ValueInput } from '@utils/formattersV2';

export const liftWithConfidenceText = (
  lift: ValueInput,
  confidence: ValueInput
) =>
  `${formatters.lift(lift, { decimals: 1 })} (${formatters.confidenceLevel(confidence, lift)} Confidence)`;
